<template>
    <div class="commenTop">
        <!-- <div class="banner">
            <img :src="imgSrc" alt="" class="bannerImg">
            <div class="mainBox textBox">
                <span class="bannerTitle">{{title}}</span>
                <span class="textEnglish">{{EnglishTitle}}</span>
            </div>
        </div> -->
        <div class="navBox">
            <div class="mainBox nav">
                <ul class="tabBox">
                    <li :class="tabACtive == item.id ? 'tabACtiveStyle' : ''" v-for="item in tabData" :key="item.name" @click="changeTab(item)">
                        <span>{{ item.name }}</span>
                    </li>
                </ul>
                <div class="rightBox">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item v-for="(i, index) in breadcrumbDatas" :key="index" 
                          :to="index == breadcrumbDatas.length - 1 ? '' : i.path"> 
                            <img v-if="i.path == '/' || i.path == '/home'" src="@/assets/index/home_icon.png" alt="">
                            {{ i.name }}
                        </el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    props: {
        tabData: {
            type: Array,
            default: null
        },
        breadcrumbData: {
            type: Array,
            default: null
        },
        imgSrc: String,
        title: String,
        EnglishTitle: String,
    },
    data(){
        return {
            tabACtive: 0,
            breadcrumbDatas:[]
        }
    },
    watch: {
      $route(){
        // sessionStorage.removeItem('currentPage');
        if(this.$route.path.indexOf('information/index') > -1 ){
          sessionStorage.removeItem('currentPage')
        }
        
        this.breadcrumbDatas = this.breadcrumbData.splice(0,2)
        if (this.tabData && this.tabData.length > 0){
            let type = this.$route.query.type ? this.$route.query.type : 0;
            this.tabACtive = type ;
            this.breadcrumbDatas.push(this.tabData[type]);
            // this.breadcrumbDatas[this.breadcrumbDatas.length - 1].path += '?type=' + type
        }
      }
    },
    mounted(){
        // this.breadcrumbDatas = this.breadcrumbData;
        this.breadcrumbDatas = this.breadcrumbData.splice(0,2)
        if (this.tabData && this.tabData.length > 0){
          let type = this.$route.query.type ? this.$route.query.type : 0;
          this.tabACtive = type ;
          this.breadcrumbDatas.push(this.tabData[type]);
          // this.breadcrumbDatas[this.breadcrumbDatas.length - 1].path += '?type=' + type
          // this.breadcrumbDatas[this.breadcrumbDatas.length - 1].path=''

          // this.tabData.forEach(item => {
          //     if (this.$route.path == item.path){
          //         this.tabACtive = item.id
          //         this.breadcrumbDatas.push(item)
          //     }
          // })
        }
        
        this.tabACtive = this.$route.query.type ? this.$route.query.type : 0;
    },
    methods: {
      changeTab(item){
        this.tabACtive = item.id
        this.$router.push({
          path: item.path,
            query: {
                type: item.id
            }
        }, () => {})
      }
    }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/index.scss";
.commenTop{
    width: 100%;
    height: fit-content;
    padding:  0 $padding-both;
    background-color: #fff;
    .navBox{
        width: 100%;
        height: 68px;
        background-color: #fff;
        // border-bottom: 1px solid #E6E6E6;
        .nav{
            height: 100%;
            .tabBox{
                height: 100%;
                float: left;
                width: fit-content;
                display: flex;
                li{
                    height: 100%;
                    width: 170px;
                    display: flex;
                    justify-content: center;
                    align-items: centers;
                    span{
                      font-size: 16px;
                      font-family: PingFang SC;
                      font-weight: 400;
                      color: #333333;
                      font-family: PingFang SC;
                      line-height: 68px;
                      cursor: pointer;
                    }
                    &:hover{
                        background: #008DD6;
                        span{
                            color: #fff;
                            font-weight: 500;
                        }
                    }
                }
                .tabACtiveStyle{
                    background: #008DD6;
                    span{
                        color: #fff;
                        font-weight: 500;
                    }
                }
            }
            .rightBox{
                height: 100%;
                float: right;
                width: fit-content;
                .el-breadcrumb{
                    height: 100%;
                    span{
                        line-height: 68px;
                        font-size: 16px;
                        font-family: PingFang SC;
                        font-weight: 400;
                        color: #333333;
                    }
                }
                
            }
        }
    }
}

</style>
<style lang="scss">
.commenTop{
    border-bottom: 1px solid  #E6E6E6;
    .navBox{
        .el-breadcrumb__item{
            img{
                width: 13px !important;
                height: 13px !important;
                margin-right: 5px;
            }
        }
        .el-breadcrumb__inner a:hover, .el-breadcrumb__inner.is-link:hover{
            color: #008DD6 !important;
        }
    }
    .el-breadcrumb span{
        &:last-child{
            span{
                color: #008DD6;
            }
        }
    }
}

</style>